import React, {useEffect} from 'react';
import {useDispatch} from 'react-redux'
import Header from './Header';
import Menu from './Menu';
import * as userActions from '../../redux/User/actions';
import PageBaseContent from './PageBaseContent';
import {isTrue} from "../../utils/general";
import {isSandbox} from "../../utils/user";

import './pageBase.scss';

const log = require("loglevel").getLogger("PageBase");
log.setLevel("debug");

const PageBase = props => {
	const { hideHeader, hideRefresh, loading, title, removeMargins, style, bodyBg='transparent', headerLinkText, headerLinkTarget } = props;
	const dispatch = useDispatch();
	const userOnSandbox = isSandbox();

	useEffect(() => {
		const pingInterval = setInterval(() => {
			try {
				dispatch(userActions.ping());
				console.log("ping ok");
			}
			catch(e) {
				console.log("ping failed");
				clearInterval(pingInterval);
			}
		}, 1000 * 60);

		return () => {
			clearInterval(pingInterval);
		}
	}, []);

	if(isTrue(loading)) {
		return <div />;
	}

	return (
		<div className="pageBaseWrapper" style={style}>
			<div className="pageBaseContainer">
				<Menu />
				<div className="pageBase">
					{ !hideHeader && <Header hideRefresh={hideRefresh} title={title} headerLinkText={headerLinkText} headerLinkTarget={headerLinkTarget} /> }
					<div className="pageBaseContent" style={{backgroundColor: bodyBg, border: userOnSandbox ? '1px solid red' : '0'}}>
						<div className="pageBaseInnerBody">

							<PageBaseContent removeMargins={removeMargins} hasTitle={title != null} allowScroll>
								{ props.children }
							</PageBaseContent>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
};

export default PageBase;
